var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useAppSelector } from "@/hooks/store";
import { Slot } from "@/utils/types/layout";
import AddWidgetControl from "@/components/layout/edit/addWidget";
import WidgetGrid from "../widgetGrid";
import { useFilteredWidgets } from "@/utils/themes/hooks";
export default function HeaderEnd() {
    var filteredWidgets = useFilteredWidgets(Slot.HEADER_CENTER);
    var isEditingLayout = useAppSelector(function (state) { return state.layout.editingLayout; });
    if (filteredWidgets.length === 0 && !isEditingLayout) {
        return _jsx(_Fragment, {});
    }
    return (_jsxs("div", __assign({ className: " ".concat(isEditingLayout && "border-[2px] border-[var(--colors-widget-border)]", "  flex h-full mx-auto direction-horizontal header_center") }, { children: [_jsx("div", __assign({ className: "relative  ".concat(isEditingLayout && "p-1.5", " h-full overflow-hidden widgets-container small scroll-elements") }, { children: _jsx(WidgetGrid, { isSmallSlot: true, filteredWidgets: filteredWidgets, isEditingLayout: isEditingLayout }) })), isEditingLayout && _jsx(AddWidgetControl, { to: Slot.HEADER_CENTER })] })));
}
